import { Link } from "react-router-dom";

const STATS = [
  { value: "8+", label: "覆盖黄金品种" },
  { value: "09:00-24:00", label: "交易日更新时段" },
  { value: "4", label: "核心资讯栏目" },
];

export default function SiteIntro() {
  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
        <div className="relative rounded-lg overflow-hidden h-72 md:h-96">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20editorial%20still%20life%20of%20gold%20bullion%20bars%20and%20coins%20arranged%20on%20a%20deep%20navy%20marble%20surface%20with%20soft%20warm%20golden%20lighting%2C%20premium%20financial%20brand%20aesthetic%2C%20high%20detail%2C%20shallow%20depth%20of%20field&width=1000&height=750&seq=intro-01&orientation=landscape"
            alt="黄金投资信息平台"
            title="黄金 - 权威黄金行情与投资指导平台"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute bottom-5 left-5 right-5 rounded-lg bg-accent-950/80 backdrop-blur p-4 border border-white/10">
            <p className="text-xs text-foreground-300 mb-1">专业 · 及时 · 权威</p>
            <p className="text-sm text-foreground-50">围绕黄金行情与投资决策的一站式信息平台</p>
          </div>
        </div>

        <div>
          <span className="inline-flex items-center gap-2 text-xs font-label text-primary-700 mb-3">
            <span className="w-6 h-px bg-primary-500" />
            关于本站
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-4">
            科学把握黄金投资机会
          </h2>
          <p className="text-sm text-foreground-600 leading-relaxed mb-4">
            本站以「黄金」为品牌，聚焦黄金价格行情、市场分析与投资资讯三大方向。我们汇总黄金现货与期货
            的核心品种价格与涨跌动态，并提供结构化的市场分析内容，帮助个人投资者、理财顾问与财经研究人员
            更高效地获取所需信息。
          </p>
          <p className="text-sm text-foreground-600 leading-relaxed mb-8">
            网站内容涵盖行情数据展示、深度市场分析与投资策略建议，力求在专业性与易读性之间取得平衡，
            为您的黄金投资决策提供清晰、稳健的信息参考。
          </p>

          <div className="grid grid-cols-3 gap-4 mb-8">
            {STATS.map((stat) => (
              <div key={stat.label} className="p-4 rounded-lg border border-background-200 bg-background-50">
                <p className="font-heading font-bold text-lg text-primary-700 mb-1">{stat.value}</p>
                <p className="text-xs text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>

          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-accent-950 hover:bg-accent-900 text-foreground-50 text-sm font-medium whitespace-nowrap transition-colors"
          >
            了解我们
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}